import React, { useEffect, useRef } from "react";
import * as echarts from "echarts";

const EChart = ({ option, style, className }) => {
  const chartRef = useRef(null);
  const instanceRef = useRef(null);

  useEffect(() => {
    if (!chartRef.current) return;

    // init solo una vez
    if (!instanceRef.current) {
      instanceRef.current = echarts.init(chartRef.current);
    }

    instanceRef.current.setOption(option, true);

    const handleResize = () => {
      instanceRef.current && instanceRef.current.resize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      // NO dispose acá si el componente sigue en uso; se hace al unmount real
    };
  }, [option]);

  useEffect(() => {
    const resizeObserver =
      chartRef.current && typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(() => {
            instanceRef.current?.resize();
          })
        : null;

    if (resizeObserver && chartRef.current) {
      resizeObserver.observe(chartRef.current);
    }

    return () => {
      resizeObserver?.disconnect();
      // dispose al desmontar
      if (instanceRef.current) {
        instanceRef.current.dispose();
        instanceRef.current = null;
      }
    };
  }, []);

  return (
    <div
      ref={chartRef}
      className={className}
      style={style || { width: "100%", height: 350 }}
    />
  );
};

export default EChart;
